import { Box, styled, useMediaQuery } from '@mui/material';
import HeaderSidebar from 'components/app/HeaderSidebar';
import React from 'react';
import { useAppSelector } from '../../app/hooks';
import { getInitials } from '../../app/utils';
import { useDrawer } from '../app/DrawerContext'; // You'll need to create this context

// Styled main content component that adjusts based on drawer state
const MainContent = styled('main', {
  shouldForwardProp: (prop) => prop !== 'drawerOpen' && prop !== 'isMobile'
})<{ drawerOpen?: boolean; isMobile?: boolean }>(({ theme, drawerOpen, isMobile }) => ({
  flexGrow: 1,
  backgroundColor: '#fafcfb',
  backgroundSize: 'cover',
  backgroundPosition: 'center center',
  minHeight: '100vh',
  transition: theme.transitions.create(['margin', 'padding'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen
  }),
  // Adjust padding based on drawer state
  paddingTop: '85px',
  paddingLeft: isMobile
    ? theme.spacing(2)
    : drawerOpen
    ? '295px' // drawer width + some spacing
    : '75px', // collapsed drawer width + some spacing
  paddingRight: isMobile ? theme.spacing(2) : theme.spacing(0),
  paddingBottom: theme.spacing(4)
}));

// Wrapper component that uses the drawer context
const AppLayoutContent: React.FC<any> = (props: any) => {
  const { children } = props;
  const { user_details } = useAppSelector((state) => state.appData);
  const initials = getInitials(user_details.name);
  const isMobile = useMediaQuery('(max-width: 900px)');
  const { drawerOpen } = useDrawer(); // Get drawer state from context

  return (
    <>
      <HeaderSidebar username_initials={initials} />
      <MainContent drawerOpen={drawerOpen} isMobile={isMobile}>
        <Box display="flex" flexDirection="column" height="100%">
          {children}
        </Box>
      </MainContent>
    </>
  );
};

// Main AppLayout component (DrawerProvider should only be at the top level in App.tsx)
const AppLayout: React.FC<any> = (props: any) => {
  return <AppLayoutContent {...props} />;
};

export default AppLayout;
